import { MessageHelper } from "../helper/message-helper";
import { UrlHelper } from "../core/html/url-helper";
import { DialogResultVm } from "../checkresultdialog/dialogresultvm";

export class UploadLogoTemplate {
	constructor(public fileId: KnockoutObservable<number>) {
	}

	public uploadFile = (e: any) => {
		let file = e.target.files[0];
		let reader = new FileReader();
		reader.onloadend = async (onloadendEvent) => {
			try {
				let result = reader.result.toString();
				let params = {
					data: result.split("base64,")[1],
					fileName: file.name,
					mimeType: file.type
				};
				let id = await DialogResultVm.getDataWithWarningDialogRetryAsync({
					url: UrlHelper.getUploadFileHandleUrl(),
					params,
					method: "POST",
					errorMessage: "Das Logo konnte nicht hochgeladen werden",
					title: "Logo hochladen"
				});
				if (id) {
					MessageHelper.uiSuccess("Das Logo wurde erfolgreich hochgeladen");
					this.fileId(id);
				}
			} catch (err) {
				MessageHelper.uiSuccess("Das Logo konnte nicht hochgeladen werden");
			}
		};

		if (file) {
			reader.readAsDataURL(file);
		}
	}
}